import Vue from 'vue';
import {
  SuperDate, Money, ListFactory,
} from '@razlet/utils';
import Accreditation from './accreditation';
import Contractor from './contractor';
import Fop from './fop';

export default class Contract {
  data = null;
  contractor = null;
  accreditation = null;

  balance = null;
  beginDate = null;
  finishDate = null;

  fops = [];

  constructor (data) {
    this.data = data;

    if (data && data.contractor) this.contractor = new Contractor(data.contractor);
    if (data && data.questionnaire) this.accreditation = new Accreditation(data.questionnaire);
    if (data && data.begin) this.beginDate = new SuperDate(data.begin);
    if (data && data.finish) this.finishDate = new SuperDate(data.finish);

    if (data.fopList) {
      this.fops = ListFactory.create(Fop, data.fopList);
    }
  }

  addBalance (money) {
    this.balance = money ? new Money(money) : null;
  }

  get hasFops () {
    return !!this.fops;
  }

  get id () {
    return this.data.id;
  }

  get account () {
    return this.data.accountNumber;
  }

  get type () {
    return this.data.type;
  }

  get isShipper () {
    return this.type === 'shipper';
  }

  get currency () {
    return this.data.currency;
  }

  get saleOrigin () {
    return this.data.saleOrigin;
  }

  get foundationShipment () {
    return this.data.foundationShipment;
  }

  get dateRange () {
    return `${this.beginDate.date || '...'} - ${this.finishDate?.date || '...'}`;
  }

  get contractor () {
    return this.contractor;
  }

  get companyMarker () {
    return this.data.companyData ? this.data.companyData.marker : '';
  }

  get companyName () {
    // eslint-disable-next-line vue/max-len
    if (!this.companyMarker || !Vue.prototype.$userData?.profile.availableAirlines[this.companyMarker]) return '';
    return Vue.prototype.$userData?.profile.availableAirlines[this.companyMarker].name;
  }

  get companyId () {
    return this.data.companyData ? this.data.companyData.id : null;
  }

  get withBalance () {
    return this.data.withBalance || false;
  }

  get fullName () {
    return `${this.contractor.name} | ${this.account}`;
  }

  get abilityProps () {
    return { company: this.companyMarker };
  }
};
